import type { IconSvgObject } from './types';

const HeartAddIcon: IconSvgObject = [
  ["path", { d: "M14 16H17.5M17.5 16H21M17.5 16V12.5M17.5 16V19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13.522 19.5C12.607 20.1358 12 20.5 12 20.5C12 20.5 2 14.5 2 8.69444C2 5.82563 4.10526 3.5 7 3.5C8.5 3.5 10 4 12 6C14 4 15.5 3.5 17 3.5C19.8947 3.5 22 5.82563 22 8.69444C22 9.48023 21.8168 10.2696 21.5 11.0471", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default HeartAddIcon;
